import React from "react";
import { CartItem } from "./CartItem";

const CartList = ({ cart }) => {
  return (
    <div>
      {cart.items.map((item, i) => (
        <CartItem item={item} key={i} />
      ))}
    </div>
  );
};

export default CartList;
